import { ConnectionState } from '../types';

const incorrectCredentialsError =
  'The username and password entered is incorrect. Please ask your client to verify their login details and try again.';
const mfaError =
  'The security question answer entered is incorrect. Please ask your client to verify their answer and try again.';
const setupRequiredError =
  'The connection is unable to fetch data because of a required client action. Please ask your client to log into their bank account and perform the required action such as removing ads or accepting terms of service.';
const lockedError =
  'Your client`s account is locked for security reasons. Please ask your client to contact their financial institution to resolve the issue before reconnecting their account.';
const temporaryError =
  'This bank connection was established. If it remains disconnected in a few days, further action will be required.';

const statesToMessages = {
  [ConnectionState[ConnectionState.INSUFFICIENT_CREDENTIALS]]: incorrectCredentialsError,
  [ConnectionState[ConnectionState.INVALID_CREDENTIALS]]: incorrectCredentialsError,
  [ConnectionState[ConnectionState.INVALID_MFA]]: mfaError,
  [ConnectionState[ConnectionState.ITEM_LOCKED]]: lockedError,
  [ConnectionState[ConnectionState.INCOMPLETE]]: temporaryError,
  [ConnectionState[ConnectionState.TEMP_ERROR]]: temporaryError,
  [ConnectionState[ConnectionState.ITEM_LOGIN_REQUIRED]]:
    'The client`s login or multi-factor authentication information is out of date. Please ask your client to re-enter their credentials and security answers.',
  [ConnectionState[ConnectionState.ITEM_NOT_SUPPORTED]]:
    'The bank account is not supported due to restrictions placed by the financial institution.',
  [ConnectionState[ConnectionState.USER_SETUP_REQUIRED]]: setupRequiredError,
  [ConnectionState[ConnectionState.MFA_NOT_SUPPORTED]]:
    'This form multi-factor authentication is not supported.',
  [ConnectionState[ConnectionState.NO_ACCOUNTS]]:
    'There are no open accounts associated with this login. Please ask your client to verify the correct institution has been selected.',
  [ConnectionState[ConnectionState.NOT_READY]]:
    'Data for this connection is still being fetched from the institution by our source. Once complete we will sync automatically.',
  [ConnectionState[ConnectionState.REMOVED_FROM_SOURCE]]:
    'This connection has been removed from our source. Please delete this connection and ask the client to reconnect.',
  [ConnectionState[ConnectionState.MISSING_PERMISSIONS]]:
    'This connection is missing required permissions from the source in order to pull data. Please ask your client to reconnect the account and accept the permissions.',
};

export default statesToMessages;
